import { render } from "./HealthCheckManageWatchlistsModal.vue?vue&type=template&id=60ea65c7"
import script from "./HealthCheckManageWatchlistsModal.vue?vue&type=script&lang=js"
export * from "./HealthCheckManageWatchlistsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__